import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  Inject,
  forwardRef
} from "@angular/core";

//Services
import { TlaService } from "app/core/services/tla.service";
import { DimmerService } from "app/core/services/dimmer.service";
import { ProgramOutcomeService } from "app/core/services/program-outcome.service";
import { QuestionService } from "app/core/services/question.service";
import { CourseOutcomeService } from "app/core/services/course-outcome.service";
import { AssessmentService } from "app/core/services/assessment.service";
import { AlertService } from "app/core/services/alert.service";

//Models
import { UserStep } from "app/core/models/user-step";
import { Question } from "app/core/models/question";
import { QuestionAnswerOption } from "app/core/models/question-answer-option";
import { QuestionTextAnswer } from "app/core/models/question-text-answer";
import { Dialog } from "app/core/models/dialog";
import { CurriculumReview } from "app/core/models/curriculum-review";
import { ProgramOutcome } from "app/core/models/program-outcome";
import { CourseOutcomeSelectedAssessmentMethod } from "app/core/models/course-outcome-selected-assessment-method";
import { CourseOutcomeSelectedTlaOption } from "app/core/models/course-outcome-selected-tla-option";
import { AssessmentFormat } from "app/core/models/assessment-format";
import { TlaFormat } from "app/core/models/tla-format";
import { CourseOutcomeFormat } from "app/core/models/course-outcome-format";
import { AssessmentSelectedMethod } from "app/core/models/assessment-selected-method";
import { TlaSelectedOption } from "app/core/models/tla-selected-option";
import { UserCourseOutcome } from "app/core/models/user-course-outcome";
import { CustomError } from "app/core/models/custom-error";
import { CourseOutcome } from "app/core/models/course-outcome";
import { Loading } from "app/core/models/loading";

//Libraries
import { Observable } from "rxjs";
import { map, catchError, finalize } from "rxjs/operators";


@Component({
  selector: "app-user-step-course-outcome",
  templateUrl: "./user-step-course-outcome.component.html",
  styleUrls: [
    "./user-step-course-outcome.component.scss",
    "../user.shared.scss"
  ]
})
export class UserStepCourseOutcomeComponent implements OnInit {
  @Input()
  courseId: number;
  @Input()
  review: CurriculumReview;
  @Input()
  assessmentFormat: AssessmentFormat;
  @Input()
  tlaFormat: TlaFormat;

  loading: Loading;

  //errors
  loadError: CustomError;
  actionErrors: Array<CustomError> = [];

  //flags
  shouldShowForm: boolean = false;
  isDescriptionFilled: boolean = true;

  courseOutcomesLoaded: boolean = false;
  assessmentMethodsLoaded: boolean = false;
  selectedAssessmentMethodsLoaded: boolean = false;

  tlaOptionsLoaded: boolean = false;
  selectedTlaOptionsLoaded: boolean = false;
  ploLoaded: boolean = false;

  shouldShowDetail: Array<boolean> = []; //whether to show/hide course outcome section

  formProcessing: boolean = false;

  //data
  courseOutcomeFormat: CourseOutcomeFormat;
  courseOutcomes: Array<CourseOutcome> = [];

  assessmentMethodsForCourse: Array<AssessmentSelectedMethod> = [];
  tlasForCourse: Array<TlaSelectedOption> = [];

  programOutcomes: Array<ProgramOutcome> = [];

  //for form
  courseOutcomeForForm: CourseOutcome;
  assessmentIdsForForm: Array<boolean> = [];
  tlaIdsForForm: Array<boolean> = [];
  formDataLoading: boolean = false;

  showAll: boolean = false;

  //delete pending course outcome
  deletePendingCourseOutcome: UserCourseOutcome;
  dialogUpdating: boolean = false;

  //additional questions
  questionsForForm: Array<Question> = [];
  relatingTo: string = "outcome";


  submitted: boolean = false;


  dialog: Dialog;

  constructor(
    private tlaService: TlaService,
    private dimmerService: DimmerService,
    private questionService: QuestionService,
    private courseOutcomeService: CourseOutcomeService,
    private assessmentService: AssessmentService,
    private alertService: AlertService,
    private programOutcomeService: ProgramOutcomeService
  ) { }

  /************************
   * Get course outcomes
   ************************/
  // async getCourseOutcomes(courseId: number) {

  //   try {
  //     const courseOutcomes = await this.courseOutcomeService.getCourseOutcomes(courseId);
  //     return courseOutcomes;
  //   }
  //   catch (error) {
  //     throw error;
  //   }

  // }

  async ngOnInit() {
    this.loading = new Loading(true, "Loading course outcomes..");

    try {
      // let courseOutcomes = await this.getCourseOutcomes(this.courseId);
      const courseOutcomes = await this.courseOutcomeService.getCourseOutcomes(this.courseId);
      this.courseOutcomes = courseOutcomes;
    } catch (error) {
      //TODO handle error
      console.log(error);
      this.loadError = error;
    } finally {
      this.loading.isLoading = false;
    }
  }

  // /////////////////////////////////////////////// Add/Edit new Course outcome /////////////////////////////////////////

  /************************************
   * open add new course outcome form
   ***********************************/
  openAddCourseOutcomeForm() {
    //create a new object
    this.courseOutcomeForForm = new CourseOutcome(null, null);

    this.dimmerService.dimWindow(true);
    this.shouldShowForm = true;
  }

  /************************************
   * Edit existing course outcome form
   ***********************************/

  editCourseOutcomeForm(courseOutcome: CourseOutcome) {
    this.courseOutcomeForForm = new CourseOutcome(
      courseOutcome.id,
      courseOutcome.description
    );

    this.dimmerService.dimWindow(true);
    this.shouldShowForm = true;
  }

  /*****************************
   * Add course outcome
   ***************************/
  addCourseOutcome(courseId: number, outcome: CourseOutcome) {
    return this.courseOutcomeService.addCourseOutcome(courseId, outcome).then(
      (outcome: CourseOutcome) => outcome,
      error => {
        throw error;
      }
    );
  }

  /*****************************
   * Update Course Outcome
   ***************************/
  updateCourseOutcome(courseId: number, outcome: CourseOutcome) {
    return this.courseOutcomeService
      .updateCourseOutcome(courseId, outcome)
      .then(
        (outcome: CourseOutcome) => outcome,
        error => {
          throw error;
        }
      );
  }

  /*****************************
   * Submit course outcome form
   ***************************/
  async submitForm() {

    this.submitted = true;

    //check if input is all whitespace  
    if (!this.courseOutcomeForForm.description || this.courseOutcomeForForm.description.trim().length == 0) {

      this.isDescriptionFilled = false;
    }
    else {
      this.isDescriptionFilled = true;

      this.formProcessing = true;
      this.actionErrors = [];


      try {
        if (!this.courseOutcomeForForm.id) {
          //create a new outcome

          let newOutcome = await this.addCourseOutcome(
            this.courseId,
            this.courseOutcomeForForm
          );

          this.courseOutcomes.push(newOutcome);
        } else if (this.courseOutcomeForForm.id) {
          let updatedOutcome = await this.updateCourseOutcome(
            this.courseId,
            this.courseOutcomeForForm
          );

          for (let courseOutcome of this.courseOutcomes) {
            if (courseOutcome.id == updatedOutcome.id) {
              courseOutcome = updatedOutcome;
              break;
            }
          }

          for (let i of Object.keys(this.courseOutcomes)) {
            if (this.courseOutcomes[i].id == updatedOutcome.id) {
              this.courseOutcomes[i] = updatedOutcome;
              break;
            }
          }
        }
      } catch (error) {
        this.actionErrors.push(error);
        window.scrollTo(0, 0);
      } finally {
        this.shouldShowForm = false;
        this.formProcessing = false;
        this.dimmerService.dimWindow(false);
      }
    }



  }

  /************************************
   * Delete course outcome
   ***********************************/
  deleteCourseOutcome(courseOutcome: UserCourseOutcome) {
    //copy the object so proceedDelete function has access to it.
    this.deletePendingCourseOutcome = courseOutcome;

    this.dimmerService.dimWindow(true);
    this.dialog = new Dialog(
      true,
      "Please Confirm",
      'Are you sure you want to delete this course outcome "' +
      courseOutcome.description +
      '" ?',
      "No, don't delete",
      "Yes, delete the Course Outcome",
      "Processing.."
    );
  }

  closeDialog() {
    this.clearAll();
  }

  async proceedDelete() {
    // this.showSavingStatus("saving", "Deleting course outcome...", "");

    this.dialogUpdating = true;

    try {
      await this.courseOutcomeService.deleteCourseOutcome(
        this.courseId,
        this.deletePendingCourseOutcome.id
      );

      for (let key of Object.keys(this.courseOutcomes)) {
        if (
          this.courseOutcomes[+key].id == this.deletePendingCourseOutcome.id
        ) {
          this.courseOutcomes.splice(+key, 1);
          break;
        }
      }
    } catch (error) {
      console.log(error);
      this.actionErrors.push(error);
    } finally {
      this.dialogUpdating = false;
      this.dialog.show = false;
      this.dimmerService.dimWindow(false);
    }
  }

  handleActionErrors() {
    //show alert - warning
    this.alertService.showAlert(
      false,
      "Error while updating the database.",
      false,
      this.actionErrors
    );
  }

  cancelForm() {
    this.clearAll();
  }

  clearAll() {
    if (this.loading) this.loading.isLoading = false;
    if (this.dialog) this.dialog.show = false;
    this.shouldShowForm = false;
    this.dimmerService.dimWindow(false);
    this.assessmentIdsForForm = [];
    this.tlaIdsForForm = [];
    this.formProcessing = false;
    this.dialogUpdating = false;
  }
}
